import React from 'react';
import { useNavigate } from 'react-router-dom';

const Logout = () => {

  const navigate = useNavigate();

  const redirectToHome = () => {
    navigate("/", {replace: true});
  };

  return (
    <div>
      <h2>Logout Page</h2>
      {/* Add content for the logout page */}
      You've been logged out successfully!
      <button onClick={redirectToHome}>Home</button>
    </div>
  );
}

export default Logout;